import IconButton from "@pathwright/ui/src/components/button/IconButton"
import { ConnectStores } from "lib/core/store"
import PropTypes from "prop-types"
import React from "react"
import StepCommentField from "./StepCommentField"
import StepCommentPreview from "./StepCommentPreview"
import "./styles/StepCommentFieldContainer.css"

const btnProps = {
  styleType: "blank",
  color: "#888"
}

class StepCommentFieldContainer extends React.Component {
  state = { expanded: this.props.required }

  handleExpand = () => {
    return this.setState({
      expanded: true
    })
  }

  handleCollapse = () => {
    return this.setState({
      expanded: false
    })
  }

  render() {
    if (this.props.disabled) {
      return null
    }

    return (
      <div className="StepComment">
        {(() => {
          if (this.state.expanded) {
            return (
              <StepCommentField
                comment={this.props.comment}
                required={this.props.required}
                onChange={this.props.changeComment}
              />
            )
          } else if (this.props.comment) {
            return <StepCommentPreview comment={this.props.comment} />
          }
        })()}
        {(() => {
          if (this.state.expanded) {
            if (!this.props.required) {
              return (
                <IconButton
                  {...Object.assign({}, btnProps, {
                    icon: "x",
                    onClick: this.handleCollapse
                  })}
                />
              )
            }
          } else {
            if (this.props.comment) {
              return (
                <IconButton
                  {...Object.assign({}, btnProps, {
                    icon: "edit",
                    onClick: this.handleExpand
                  })}
                />
              )
            } else {
              return (
                <a href="javascript:void(0)" onClick={this.handleExpand}>{`\
Leave a comment?\
`}</a>
              )
            }
          }
        })()}
      </div>
    )
  }
}

StepCommentFieldContainer.displayName = "StepCommentFieldContainer"

StepCommentFieldContainer.contextTypes = { user: PropTypes.object }

const mapStateToProps = function (state, ownProps) {
  const { step, completion, comment } = state.stepStore.state
  const { changeComment } = state.stepStore.action
  const status =
    (step != null ? step.completion_comment_required_status : undefined) || "D"
  const disabled = status === "D"
  const required = status === "R"

  return _.assign(
    {},
    {
      disabled,
      required,
      comment,
      completion,
      changeComment
    },
    ownProps
  )
}

const stores = [{ store: "step", watch: ["step", "comment"] }]

export default ConnectStores(
  StepCommentFieldContainer,
  stores,
  {},
  mapStateToProps,
  true
)
